import { render, staticRenderFns } from "./JobBoard.vue?vue&type=template&id=551c02ab&scoped=true&"
import script from "./JobBoard.vue?vue&type=script&lang=ts&"
export * from "./JobBoard.vue?vue&type=script&lang=ts&"
import style0 from "./JobBoard.vue?vue&type=style&index=0&id=551c02ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551c02ab",
  null
  
)

export default component.exports